// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__TL2qX","wide":"Loader_wide__xtL6v"};